import { default as jQuery } from './jquery-3.7.1.min.mjs';
window.jQuery = jQuery
window.$ = jQuery